/* eslint-disable import/no-anonymous-default-export */
import apiCall from "./apiCall";

export default {

    async getReportFormats() {
      const response = await apiCall("system/report.formats", []);
      return response;
    },

    async getPrimarySCales() {
      const response = await apiCall("grading/primary/list", []);
      return response;
    },

    async getAdvancedSCales() {
      const response = await apiCall("grading/advanced/list", []);
      return response;
    },

  
}